module.exports = __webpack_public_path__ + "static/media/instrumentacion-01.dfbcdaa8.jpg";